import styled from '@emotion/styled';
import type { ItemName } from '@ps-smart-cp/ppfw-client';
import { useItemName } from '@ps-smart-cp/ppfw-client';
import { Link } from 'react-router';

interface JsonObject {
  [key: string]: JsonValue;
}
type JsonValue = string | number | boolean | null | JsonValue[] | JsonObject;

interface NotificationLink {
  itemName: ItemName;
  path: string;
  state?: Record<string, JsonValue>;
}

interface Notification {
  message: string;
  link?: NotificationLink;
}

interface NotificationListProps {
  notifications: Notification[];
}

const MessageList = styled.ul`
  padding: 8px 16px;
  margin-top: 0px;
  margin-bottom: 0px;
`;

const NotificationItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  color: #222222;
  font-size: 12px;
  list-style: none;
  white-space: pre-wrap;
`;

function NotificationList({ notifications }: NotificationListProps) {
  const getName = useItemName();

  return (
    <MessageList className="notification">
      {notifications.map((notification, index) => (
        <NotificationItem key={index}>
          <span>
            <span>{notification.message}</span>
            {notification.link && (
              <>
                <br />
                <Link to={notification.link.path} state={notification.link.state}>
                  {getName(notification.link.itemName)}
                </Link>
              </>
            )}
          </span>
        </NotificationItem>
      ))}
    </MessageList>
  );
}

export type { Notification, NotificationLink, NotificationListProps };
export { NotificationList };
